<template>
    <c-dialog ref="dialog" width="500" height="340" @resolve="editHandle">
        <c-form ref="form" unit-width="80%">
            <c-form-item :label="businessType === 1 ? '客户' : '供应商'" required :tip="amount_tip">
                <c-select name="target_id" async
                          @search="searchTarget(businessType === 1?'SALE_CUSTOMER':'SUPPLIER',arguments[0], arguments[1])"
                          @change="changeTarget($event,businessType === 1?'SALE_CUSTOMER':'SUPPLIER')"
                ></c-select>
            </c-form-item>

            <c-form-item label="本次核销金额" required>
                <c-input name="amount" class="m-price-input" type="number" decimal="2"
                         :range="[0.01, businessType === 1?this.advance_receipt_amount:this.advance_payment_amount]"
                         placeholder="请输入核销金额" append-text="元"></c-input>
            </c-form-item>

            <c-form-item label="备注">
                <c-input type="textarea" name="remark" maxlength="500"  placeholder="请输入备注说明（选填）"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'advanceWriteOffDialog',
    props: {
        businessType: {
            type: Number,
            default: 1   // 1-预收核销 2-预付核销
        }
    },
    data() {
        return {
            amount_tip:'',
            advance_receipt_amount:0,//预收款
            advance_payment_amount:0,//预付款
        }
    },
    methods: {
        /** 打开弹窗 */
        open() {
            this.amount_tip = '';
            this.advance_receipt_amount = 0;
            this.advance_payment_amount = 0;
            this.$refs.form.clear();
            let title = this.businessType === 1 ? '核销处理 - 预收款' : '核销处理 - 预付款';
            this.$refs.dialog.open({ title: title });
        },

        /*******搜索采购供应商*****************/
        searchTarget(code,keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:code,
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /**************变更 下拉框数据******************/
        changeTarget(selectData, type) {
            this.amount_tip = '';
            this.advance_receipt_amount = 0;
            this.advance_payment_amount = 0;
            if (type == 'SALE_CUSTOMER') {
                //客户剩余预收款
                var cent = selectData.data.advance_receipt_amount;
                this.advance_receipt_amount = (parseFloat(cent)/100);
                this.amount_tip = '客户剩余预收款￥'+(this.advance_receipt_amount.toFixed(2))+"元";
            } else {
                var cent = selectData.data.advance_payment_amount;
                this.advance_payment_amount = (parseFloat(cent)/100);
                this.amount_tip = '供应商剩余预付款￥'+(this.advance_payment_amount.toFixed(2))+"元";
            }
        },

        /** 提交处理 */
        editHandle(stop, next) {
            stop();
            let targetField = this.businessType === 1 ? '客户' : '供应商';
            this.$refs.form.submit({
                url: '/advance/receipt/payment/write/off',
                rule: {
                    target_id: '请选择' + targetField,
                    amount: [{
                        type: 'empty',
                        message: '请输入核销金额'
                    }, {
                        type: 'function',
                        fun: (value) => value > 0,
                        message: '核销金额必须大于0'
                    }]
                },
                dataFormatter: data => {
                    data.business_type = this.businessType;
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({ message: '核销处理成功', type: 'success' });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>
